// @flow
export { default } from './FakeProductCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeProductCard/index.js